import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const VacancySolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 6H15.4L10 0.6V5C10 5.6 10.4 6 11 6ZM11 8C9.3 8 8 6.7 8 5V0H3C1.3 0 0 1.3 0 3V17C0 18.7 1.3 20 3 20H13C14.7 20 16 18.7 16 17V8H11ZM5 6H6C6.6 6 7 6.4 7 7C7 7.6 6.6 8 6 8H5C4.4 8 4 7.6 4 7C4 6.4 4.4 6 5 6ZM11 16H5C4.4 16 4 15.6 4 15C4 14.4 4.4 14 5 14H11C11.6 14 12 14.4 12 15C12 15.6 11.6 16 11 16ZM11 12H5C4.4 12 4 11.6 4 11C4 10.4 4.4 10 5 10H11C11.6 10 12 10.4 12 11C12 11.6 11.6 12 11 12Z"
      fill={color}
    />
  </svg>
)

VacancySolidSvg.defaultProps = {
  width: 16,
  height: 20,
  color: colors.Primary.GreyText
}

export default VacancySolidSvg
